module.exports = __webpack_public_path__ + "static/img/bg.8f4784f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/larg/bg.png
// module id = 5SHr
// module chunks = 1